import type { CourseDetailLocalizedSectionsItemSectionsItem } from './courseDetailLocalizedSectionsItemSectionsItem';

/**
 * 언어별 커리큘럼 구성 정보
 */
export type CourseDetailLocalizedSectionsItem = {
  /** 언어 코드 (예: ko, en) */
  language: string;
  /** 해당 언어로 변환된 섹션 목록 */
  sections: CourseDetailLocalizedSectionsItemSectionsItem[];
};
